import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";

class LegacyOrganization extends React.Component {

    render() {
        return (
            <LegacyFrame withHeader={false} customFrameClass={"org-container"} pageTitle={"My Company"} formname={"table_21"} customClass={"field-customization-container org-container"} />
        );
    }
}

export default LegacyOrganization;
